(function () {
  var toggle = document.getElementById('nav-menu-toggle');
  var panel  = document.getElementById('nav-divisions');
  if (!toggle || !panel) return;
  var mq = window.matchMedia('(max-width: 767px)');

  function open() {
    panel.classList.add('is-open');
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    var h = 144;
    var annbar = document.querySelector('.ann-bar');
    if (annbar) {
      annbar.style.transition = 'transform 0.35s ease';
      annbar.style.transform = 'translateY(' + h + 'px)';
    }
  }

  function close() {
    panel.classList.remove('is-open');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    var annbar = document.querySelector('.ann-bar');
    if (annbar) { annbar.style.transform = ''; }
  }

  function isOpen() { return panel.classList.contains('is-open'); }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    if (!mq.matches) return;
    isOpen() ? close() : open();
  });

  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (panel.contains(e.target) || toggle.contains(e.target)) return;
    if (e.target.closest('.cmp-home')) return;
    close();
  });

  mq.addEventListener('change', function () { if (!mq.matches) close(); });
})();
